import React, {useCallback, useMemo} from "react";
import {Box, Select, MenuItem, FormControl} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {blue} from "@mui/material/colors";
import {styled} from "@mui/system";

import ServiceTypeTooltipLabel from "../common/ServiceTypeTooltipLabel";
import {BOOKABLE_STATUS} from "../../helpers/TimeblockHelper";

const PERFORMER_SELECTED_DARK_BLUE_COLOR = blue[700];

const bookableStatusDropdownStyle = {
    backgroundColor: PERFORMER_SELECTED_DARK_BLUE_COLOR,
    color: 'white',
    borderRadius: '1rem',
    height: 22,
    width: 135
};

const BookableStatusButtonBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    marginTop: 3,
    marginBottom: 3
}));

const WhiteArrowDropDownIcon = (props) => <ArrowDropDownIcon {...props} style={{color: 'white'}}/>;

export default function BookableStatusButton(props) {
    const {bookableServices, serviceTypePlans, bookableServiceTypes, setBookableServiceTypes} = props;

    const handleBookableStatusChange = useCallback((index, event) => {
        const updatedBookableStatusList = [...bookableServiceTypes];
        updatedBookableStatusList[index] = event.target.value;
        setBookableServiceTypes(updatedBookableStatusList);
    }, [bookableServiceTypes, setBookableServiceTypes]);

    const sortedBookableServices = useMemo(() =>
        bookableServices
            .map((service, index) => ({service, status: bookableServiceTypes[index]})),
        [bookableServices, bookableServiceTypes]
    );

    return (
        <Box>
            {sortedBookableServices.map((item, index) => (
                <BookableStatusButtonBox key={index}>
                    <ServiceTypeTooltipLabel service={item.service} serviceTypePlans={serviceTypePlans} />
                    <FormControl>
                        <Select
                            value={item.status}
                            onChange={event => handleBookableStatusChange(index, event)}
                            size="small"
                            style={bookableStatusDropdownStyle}
                            IconComponent={WhiteArrowDropDownIcon}>
                            <MenuItem value={BOOKABLE_STATUS.BOOKABLE}>{BOOKABLE_STATUS.BOOKABLE}</MenuItem>
                            <MenuItem value={BOOKABLE_STATUS.UNBOOKABLE}>{BOOKABLE_STATUS.UNBOOKABLE}</MenuItem>
                        </Select>
                    </FormControl>
                </BookableStatusButtonBox>
            ))}
        </Box>
    );
}
